module.exports = __webpack_public_path__ + "static/media/bottle2.4316eaad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/bottle2.svg
// module id = 2438
// module chunks = 7